<template>
  <generic-error>
    <template v-slot:title>Formulaire déjà soumis</template>
    <h1>Ce formulaire est déjà soumis</h1>
    <p>Aucune modification n'est permise lorsque le formulaire est soumis à l'Ordre.</p>
  </generic-error>
</template>

<script>
import GenericError from "./GenericError"
export default {
  components: {
    GenericError
  }
}
</script>

<style>
</style>
